module.exports = __webpack_public_path__ + "static/media/id1.77c0dedb.jpg";